import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    useTheme,
} from "@mui/material";
import * as React from "react";
import { IoMdClose } from "react-icons/io";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useDispatch } from "store";
import { useUpdateUserStatusMutation } from "store/slices/apis/userAccountSlice";
import {ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"

export default function UserDisabledAction(props) {
    const { open, cancel, rowData } = props;
    const theme = useTheme();
    const [userfun, userRes] = useUpdateUserStatusMutation();
    const dispatch = useDispatch();

    const openNotification = async (msg, type = "error") => {
        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: "alert",
                alert: {
                    color: type,
                },
                close: false,
            })
        );

        setTimeout(() => dispatch(closeSnackbar()), 3000);
    };



    const handleDisable = async () => {
        await userfun(rowData?.id)
    };

    React.useEffect(() => {
        if (userRes?.isSuccess) {
            if (userRes?.data?.status?.toLowerCase() == 'success') {
                openNotification(userRes?.data?.message, 'success')
            } else {
                openNotification(userRes?.data?.message, 'error')
            }
            cancel();
        }
    }, [userRes?.isSuccess]);

    React.useEffect(() => {
        if (userRes?.isError) {
            if (userRes?.error?.data?.status?.toLowerCase() == 'fail') {
                openNotification(userRes?.error?.data?.message, 'error')
            } else {
                openNotification(userRes?.error?.data?.message ?? 'Something went wrong!', 'error')
            }
            // cancel();
        }
    }, [userRes?.isError]);

    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={cancel}
                disableEnforceFocus
                disableRestoreFocus
                aria-labelledby="draggable-dialog-title"
                fullWidth={true}
                maxWidth={"sm"}
            >
                <DialogTitle
                    sx={{
                        fontWeight: 500,
                        fontSize: "20px",
                        color: "#252525",
                        paddingBottom: 0,
                    }}
                    id="draggable-dialog-title"
                >
                    User Disable
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={cancel}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    }}
                >
                    {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
                     <CrossIcon style={{ fontSize: "20px", width:"20px", height:"20px", fill:"#808080" }} />
                </IconButton>
                <DialogContent>
                    <DialogContentText
                        sx={{ fontWeight: 400, fontSize: "16px", color: "#474747" }}
                    >
                        Are you sure you want to disable this user? This action is permanent.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        loading={userRes?.isLoading}
                        onClick={handleDisable}
                        sx={{
                            backgroundColor: `${theme?.customSettings?.themeColor}`,
                            color: "#fff",
                            fontSize: "16px",
                            fontWeight: "500",
                            textTransform: "none",
                        }}
                    >
                        Disable
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
